import { get, post } from '../axios'
import store from '@/store'

/**
 * 获取子频道
 * @param {*} param
 * @returns
 */
const getCategories = ({ parentId, type, pageSize = 20 }) => {
  return get('/activity/timeline/categories', { parentId, type, pageSize })
}

/**
 * 获取话题详情
 * @param {*} id
 * @returns
 */
const getTimelineTag = (id) => {
  return get('/activity/timeline/tag', { id, token: store.getters.getToken })
}

/**
 * 获取帖子列表
 * @param {*} params
 * @returns
 */
const getPostList = (params) => {
  return get('/activity/timeline/posts', { ...params, pageSize: 5, token: store.getters.getToken })
}

/**
 * 获取频道详情
 * @param {*} id
 * @returns
 */
const getTimelineCategory = (id) => {
  return get('/activity/timeline/category', { id, token: store.getters.getToken })
}

/**
 * 获取频道子频道
 * @param {*} id
 * @returns
 */
const getTimelineChildCategory = (parentId) => {
  return get('/activity/timeline/categories', { parentId })
}

/**
 * 获取频道话题
 * @param {*} categoryId categoryId 频道id
 * @returns
 */
const getTimelineTags = (categoryId, { page = 1, pageSize = 1000, keyswords = '' }) => {
  return get('/activity/timeline/tags', { categoryId, page, pageSize, keyswords })
}

/**
 * 获取标签列表
 * @param {*} params 
 * @returns 
 */
const getTimelineTagsByParams = (params) => {
  return get("/activity/timeline/tags", params)
}


/**
 * 关注/取消关注频道
 * @param {*} categoryId
 * @param {*} isSubscribe
 */
const followCategory = (categoryId, isSubscribe) => {
  return post('/activity/timeline/category/subscribe', { categoryId, isSubscribe, token: store.getters.getToken })
}

/**
 * 关注/取消关注标签
 * @param {*} tagId
 * @param {*} isSubscribe
 * @returns
 */
const followTag = (tagId, isSubscribe) => {
  return post('/activity/timeline/tag/subscribe', { tagId, isSubscribe, token: store.getters.getToken })
}

export default {
  getTimelineTag,
  getPostList,
  getTimelineCategory,
  getTimelineChildCategory,
  getTimelineTags,
  getTimelineTagsByParams,
  getCategories,
  followCategory,
  followTag
}
